import bayonetta from "./bingoImages/bayonetta.png";
import brave from "./bingoImages/brave.png";
import buddy from "./bingoImages/buddy.png";
import captain from "./bingoImages/captain.png";
import chrom from "./bingoImages/chrom.png";
import cloud from "./bingoImages/cloud.png";
import daisy from "./bingoImages/daisy.png";
import dedede from "./bingoImages/dedede.png";
import demon from "./bingoImages/demon.png";
import diddy from "./bingoImages/diddy.png";
import dolly from "./bingoImages/dolly.png";
import donkey from "./bingoImages/donkey.png";
import duckhunt from "./bingoImages/duckhunt.png";
import edge from "./bingoImages/edge.png";
import eflame from "./bingoImages/eflame.png";
import falco from "./bingoImages/falco.png";
import fox from "./bingoImages/fox.png";
import gamewatch from "./bingoImages/gamewatch.png";
import ganon from "./bingoImages/ganon.png";
import gaogaen from "./bingoImages/gaogaen.png";
import gekkouga from "./bingoImages/gekkouga.png";
import ice_climber from "./bingoImages/ice_climber.png";
import ike from "./bingoImages/ike.png";
import inkling from "./bingoImages/inkling.png";
import jack from "./bingoImages/jack.png";
import kamui from "./bingoImages/kamui.png";
import ken from "./bingoImages/ken.png";
import kirby from "./bingoImages/kirby.png";
import koopa from "./bingoImages/koopa.png";
import koopajr from "./bingoImages/koopajr.png";
import krool from "./bingoImages/krool.png";
import link from "./bingoImages/link.png";
import littlemac from "./bingoImages/littlemac.png";
import lucario from "./bingoImages/lucario.png";
import lucas from "./bingoImages/lucas.png";
import lucina from "./bingoImages/lucina.png";
import luigi from "./bingoImages/luigi.png";
import mario from "./bingoImages/mario.png";
import mariod from "./bingoImages/mariod.png";
import marth from "./bingoImages/marth.png";
import master from "./bingoImages/master.png";
import metaknight from "./bingoImages/metaknight.png";
import mewtwo from "./bingoImages/mewtwo.png";
import miifighter from "./bingoImages/miifighter.png";
import miigunner from "./bingoImages/miigunner.png";
import miiswordsman from "./bingoImages/miiswordsman.png";
import murabito from "./bingoImages/murabito.png";
import ness from "./bingoImages/ness.png";
import packun from "./bingoImages/packun.png";
import pacman from "./bingoImages/pacman.png";
import palutena from "./bingoImages/palutena.png";
import peach from "./bingoImages/peach.png";
import pichu from "./bingoImages/pichu.png";
import pickel from "./bingoImages/pickel.png";
import pikachu from "./bingoImages/pikachu.png";
import pikmin from "./bingoImages/pikmin.png";
import pit from "./bingoImages/pit.png";
import pitb from "./bingoImages/pitb.png";
import ptrainer from "./bingoImages/ptrainer.png";
import purin from "./bingoImages/purin.png";
import reflet from "./bingoImages/reflet.png";
import richter from "./bingoImages/richter.png";
import ridley from "./bingoImages/ridley.png";
import robot from "./bingoImages/robot.png";
import rockman from "./bingoImages/rockman.png";
import rosetta from "./bingoImages/rosetta.png";
import roy from "./bingoImages/roy.png";
import ryu from "./bingoImages/ryu.png";
import samus from "./bingoImages/samus.png";
import samusd from "./bingoImages/samusd.png";
import sheik from "./bingoImages/sheik.png";
import shizue from "./bingoImages/shizue.png";
import shulk from "./bingoImages/shulk.png";
import simon from "./bingoImages/simon.png";
import snake from "./bingoImages/snake.png";
import sonic from "./bingoImages/sonic.png";
import szerosuit from "./bingoImages/szerosuit.png";
import tantan from "./bingoImages/tantan.png";
import toonlink from "./bingoImages/toonlink.png";
import trail from "./bingoImages/trail.png";
import wario from "./bingoImages/wario.png";
import wiifit from "./bingoImages/wiifit.png";
import wolf from "./bingoImages/wolf.png";
import yoshi from "./bingoImages/yoshi.png";
import younglink from "./bingoImages/younglink.png";
import zelda from "./bingoImages/zelda.png";
import random from "./bingoImages/random.png";

// 各キャラの import はそのまま（上の部分は変更不要）
// 例）import mario from "../../assets/mario.png";

export const imageMap = {
  buddy,
  koopajr,
  daisy,
  bayonetta,
  brave,
  captain,
  chrom,
  cloud,
  dedede,
  demon,
  diddy,
  dolly,
  donkey,
  duckhunt,
  edge,
  eflame,
  falco,
  fox,
  gamewatch,
  ganon,
  gaogaen,
  gekkouga,
  ice_climber,
  ike,
  inkling,
  jack,
  kamui,
  ken,
  kirby,
  koopa,
  krool,
  link,
  littlemac,
  lucario,
  lucas,
  lucina,
  luigi,
  mario,
  mariod,
  marth,
  master,
  metaknight,
  mewtwo,
  miifighter,
  miigunner,
  miiswordsman,
  murabito,
  ness,
  packun,
  pacman,
  palutena,
  peach,
  pichu,
  pickel,
  pikachu,
  pikmin,
  pit,
  pitb,
  ptrainer,
  purin,
  reflet,
  richter,
  ridley,
  robot,
  rockman,
  rosetta,
  roy,
  ryu,
  samus,
  samusd,
  sheik,
  shizue,
  shulk,
  simon,
  snake,
  sonic,
  szerosuit,
  tantan,
  toonlink,
  trail,
  wario,
  wiifit,
  wolf,
  yoshi,
  younglink,
  zelda,
  random,
};

// デフォルトエクスポートは配列（BingoCardなどで使用）
const images = Object.values(imageMap);
export default images;
